import styled from 'styled-components';


const BreadcrumbContainer = styled.div`
  padding-top: 4px;
  padding-bottom: 4px;
  background: #fff;
  border-bottom: 2px solid ${props => props.theme.colors.greyL};
  width: 100%;
  /* Deliberately no z-index here: a z-index would make the bar its own stacking context
     and cap every dropdown inside it at that level, so the account switcher, the
     breadcrumb dot popover and the add menu would open behind page modals (z-index 999,
     e.g. Site Profile). Each of those dropdowns carries its own z-index of 1000 or more
     instead, which puts it above the page content, the hierarchy and those modals. */

  /* keep the account name bounded so a long account never pushes the help/admin/avatar
     actions on the right of the top tier off the bar */
  #account-name {
    display: inline-block;
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .ui {
    &.breadcrumb {
      padding: 0;
      background: transparent;
      i.right.angle {
        margin: 0 !important;
      }
      .menu.transition.visible {
        z-index: 1000;
      }
      .section {
        color: ${props => props.theme.colors.greyXD};
        font-size: 12px;
        font-weight: 600;
        a {
          color: ${props => props.theme.colors.greyXD};
        }
      }

      a.section {
        color: ${props => props.theme.colors.greyXD};
        font-size: 12px;
        margin-top: 2px;
      }

      .divider {
        font-size: 12px;
      }
    }
  }

  ${props => props.theme.media.tablet`
    #account-name {
      max-width: 140px;
    }
  `}

  ${props => props.theme.media.phone`
    #account-name {
      max-width: 96px;
    }
  `}
`;

export default BreadcrumbContainer;
